import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async'; // ✅ Correct import
import CartPage from '../elementsui/CartPage';


const CartDesignPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top on mount
  }, []);

  return (
    <div>
      {/* ✅ SEO Meta Tags */}
      <Helmet>
        <title>Your Cart | binzal - Quick Grocery Checkout</title>
        <meta
          name="description"
          content="Review your cart items and proceed to fast checkout with binzal – Bihar's trusted delivery service for groceries and essentials."
        />
        <meta
          name="keywords"
          content="grocery cart, binzal cart, review items, fast checkout, order groceries online Bihar"
        />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Your Cart | binzal" />
        <meta
          property="og:description"
          content="View and manage your grocery cart on binzal for fast home delivery across Bihar."
        />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
      </Helmet>

      <CartPage />
    </div>
  );
};

export default CartDesignPage;
